import { gql } from '@apollo/client';

export default gql`
  query teamSchedule($input: TeamScheduleInput!) {
    teamSchedule(input: $input) {
      nextGame {
        _id
        startTimeStr
        dateStr
        opponent {
          _id
          name
        }
      }
      wins
      losses
      ties
    }
  }
`;
